function VarietyProducer(props) {
    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">제작</h4>
                <h5 className="recruit_titleline_title">예능PD</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <p className="recruit_subinfo_text">
                    예능 연출PD는 pre-production 단계에서 프로그램의 전체적인 컨셉을 잡은 후 작가와 함께 프로그램의 세부적인 룰을 결정하며, <br />
                    각 분야의 전문가인 스텝들을 중심으로 팀을 구성합니다. 이후 촬영, 녹화 준비과정부터 실제 촬영 및 촬영본 편집, 보정까지 팀원들에게<br />세부적인 방향을 제시해 줍니다.<br />
                    조연출PD는 pre-production 단계 보조를 포함해 프로그램 제작과 직결되는 촬영, 편집, 자막, CG 의뢰 등은 물론이고, 세트 의뢰, 촬영장소 답사, 연기자와의 만남, 소품 결정, 예산관리와 정산까지 프로그램을 위해 다양한 업무를 담당합니다.<br />
                    예능PD 직무를 수행하기 위해서는 평범한 일상에서 재미와 즐거움을 만들어내는 창의성이 필요하고, 제작 전 과정에 걸쳐 연기자, 작가, FD, 카메라감독 등 수많은 사람들과 협업을 하기 위한 커뮤니케이션 능력과 갈등해결능력, 매주 완성된 프로그램을 만들어내는 데 필요한 강인한 정신력과 체력이 요구됩니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                    예능본부는 SBS의 수많은 히트 예능프로그램들을 만들어 낸 명실상부 대한민국 최고의 예능제작조직입니다.<br />
                    TV 방송은 물론 각종 OTT를 통해 전 세계의 시청자와 만나는 프로그램들을 제작하는 부서(CP)에 연출과 조연출이 모두 소속되어 있으며,<br />
                    유튜브를 포함해 변화하는 환경에 대응하여 예능프로그램의 지평을 더욱 넓히는 디지털 예능부서, 전 세계의 시청자를 끌어들이고 각종 <br />
                    공연이나 해외 판권 계약도 담당하는 글로벌 담당부서를 갖추고 있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    SBS는 가장 다양한 예능프로그램 라인업을 갖추고 있습니다. 정규 프로그램뿐만 아니라 신규 및 파일럿 프로그램에 대한 지원과 모집도 활발하게 이뤄지고 있습니다. 예능PD로 입사하고 나면, 여러 프로그램에서의 실무경험을 통해 예능프로그램의 기획부터 실행까지 모든 것을 배우고, 주도적으로 업무를 수행할 수 있습니다.<br />
                    특히 SBS는 직접 기획한 프로그램을 연출하게 되는 시기가 상대적으로 빠르고, 연출기회를 공정하게 부여하는 것으로 정평이 나 있습니다. <br />
                    한두 번의 실패를 한다 해도 든든하게 기다려주는 미덕이 있는 회사이기도 합니다. <br />
                    또한, 변화하는 콘텐츠 시장에 어떤 자세로 대처할지 치열하게 고민하는 든든한 선후배들과 함께 일할 수 있는 행운이 있는 곳이기도 합니다. <br />
                    조연출 기간 많은 것을 배우고, 본인의 아이디어가 담긴 기획안을 통해 연출PD로 발돋움하여 대한민국 예능프로그램을 선도할 기회를 가질 수 있는 SBS는, 예능PD를 꿈꾸는 분들께 최고의 선택이 될 것입니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    안녕하세요, SBS 예능본부 유선명 PD입니다.<br />
                    입사 후 &#60;미운 우리 새끼&#62;, &#60;리틀 포레스트&#62;를 거쳐 현재는 &#60;런닝맨&#62;에서 조연출로 일하고 있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">예능PD가 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                    다른 예능PD들과 크게 다르지 않았던 것 같습니다. 학창시절 재밌는 영상으로 많은 사람들을 웃게 만들었을 때, 그 소리가 너무나 듣기 좋았고, 그 소리를 내가 만들어냈다는 보람이 더 좋았습니다.<br />
                    세대와 성별을 뛰어넘어 사람들이 서로 대화를 시작할 수 있게 해주는 예능프로그램을 만들고 싶었죠. 그러다 보니 어느새 예능PD로 일하고<br />
                    있네요.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    예능PD는 일주일을 주기로 살아갑니다. 촬영을 시작으로 촬영분을 편집하고 자막을 써서 매주 예능 한 편씩을 만들어가는 과정이 일주일 기준으로 규칙적으로 반복됩니다. 하지만 하루를 기준으로 한다면 매일 다른 일을 하기에 질릴 틈이 없고, 업무의 한계 없이 다양한 경험을 해볼 수 있다는 점이 매력적입니다.<br />
                    때로는 현장에서, 때로는 편집실에서, 때로는 집에서 프로그램의 완성도를 위해 일주일을 살아갑니다.<br />
                    그리고 그렇게 해서 매주 한 편씩 탄생한 가시적인 즐거움, 내가 기여한 결과물에 대해 수많은 시청자의 반응을 즉각 확인할 때 예능PD라는<br />
                    직업의 매력을 새삼 다시 느끼고, 보람도 느끼는 것 같습니다.<br />
                    소박하게, 가족이나 친한 친구들이 제 작품을 보면서 웃어줄 때, 그 동안의 고생이 모두 사라지는 느낌을 받습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    예능PD는 &#39;웃기는 사람&#39;이 아닙니다. 흔히들 예능PD가 톡톡 튀고, 웃기고, 특이한 사람이라고 생각합니다. 그러나 나를 뽐내거나 표현하고<br />싶은 만큼, 혹은 그 이상으로, 남들에 대해 이해하는 포용력과 남들을 파악하는 관찰력이 중요합니다.<br />
                    &#39;연출&#39; 은 남들이 보고 싶어하는 것과 연출자가 보여주고 싶은 것을 똑똑하게 섞어서 보여주는 것이기에 그렇습니다. <br />
                    다양한 업무를 위해 많은 사람들과 협업해야 하는 만큼 인간적 매력도 큰 도움이 됩니다. 그래서 &#39;웃기는 사람&#39;보다는 &#39;같이 일하고 싶은 사람&#39;이 예능PD와 더 어울린다고 생각합니다. 예능PD를 꿈꾸는 많은 분들께 도움이 됐으면 좋겠네요. 새로운 후배님들과 함께 일할 날을 즐거운 <br />
                    마음으로 기다리겠습니다.
                </p>
            </div>
        </div>);
}

export default VarietyProducer;

